<script lang="ts">
 /**
 * Spinner drawer shown while the AI analyzes captured photos.
 *
 * @remarks
 * Simple UDrawer with a spinning border animation and status text.
 * Closing the drawer (drag-down) resets the flow, but only if the
 * state machine is still in `processing` — the parent guards this
 * to prevent accidental resets when processing transitions
 * programmatically to `suggestion`.
 */
</script>

<script setup lang="ts">
defineProps<{
  /** Whether the drawer is open (bound to flow.isProcessing). */
  open: boolean
}>()

defineEmits<{
  /** Fired when the drawer is dragged closed. Parent guards with state check. */
  "update:open": [value: boolean]
}>()
</script>

<template>
  <UDrawer :open="open" @update:open="$emit('update:open', $event)">
    <template #content>
      <div class="flex flex-col items-center gap-4 p-6">
        <div class="border-default border-t-primary h-8 w-8 animate-spin rounded-full border-2" />
        <p class="text-muted text-sm">Analyzing image...</p>
      </div>
    </template>
  </UDrawer>
</template>
